export const TRANSACTION_STATUS_ARRAY = [
  ["Opłacone", "paid"],
  ["Nieopłacone", "unpaid"],
]

export const TRANSACTION_METHOD_TYPE_ARRAY = [
  ["Szybki przelew", "transfer"],
  ["BLIK", "blik"],
  ["Proforma", "pro_forma"],
  ["Brak", "none"],
]
